import {
  ORDERS_HISTORY_LIST
} from '../../actions/orders'
import type {
  ORDERS_HISTORY_LIST_TYPE
} from '../../actions/orders'

type State = {
  ordersHistory: Object[],
  isFetching: boolean,
  error: null | string
}

const initialState: State = {
  ordersHistory: [],
  isFetching: true,
  error: null
}

type Action =
  | ORDERS_HISTORY_LIST_TYPE

export default function ordersReducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case ORDERS_HISTORY_LIST: {
      const { orders } = action.payload
      return {
        ...state,
        ordersHistory: orders.items
      }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/orders/index.js